<template>
    <div class="w-full">
        <div class="text-9xl font-stretch-150% font-black colorful antialiased">Ooops!</div>
        <div class="pt-10 text-center">
            <h1>
                <span class="text-2xl font-bold antialiased text-slate-700">{{errorMessage}}</span>
            </h1>
        </div>
        <p class="pb-10">{{ message }}</p>
        <router-link class="bg-gradient-to-r from-blue-500 to-purple-500 hover:from-blue-600 hover:to-purple-600 shadow-xl md:inline-flex hidden items-center py-2.5 px-3 ms-2 text-sm font-medium text-white rounded-lg border-none border-indigo-700 hover:bg-indigo-800 focus:ring-4 focus:outline-none focus:ring-indigo-300 dark:bg-indigo-600 dark:hover:bg-indigo-700 dark:focus:ring-indigo-800" to="/">
            Go to Home
        </router-link>
    </div>
</template>
<script setup>
import { onMounted, ref } from "vue";
import appStore from "@/store/app.store";

const message = ref("Something went wrong!");
const errorMessage = ref("Please try again later.");

onMounted(() => {
    message.value = appStore.state.message;
    errorMessage.value = appStore.state.error;
});

</script>